import Dexie from 'dexie';

const db = new Dexie('Trader');
db.version(5).stores({
    customfields: '++id, projectId, magazineId, pagePosition',
    listViewChanges: '++id, projectId, magazineId, pagePosition',
    localSettings: '++id, key',
    localStorage: '++id, key',
    productPositionChanges: '++id, projectId, magazineId, pagePosition',
});

export default db;

